// =======================
// src/componentes/DocumentStatus.jsx
// =======================
import React from 'react';
import { styled } from '@mui/material/styles';
import { ajustarTamanhoFonteEscola } from "../estilos/global";

// Badge estilizado
const StatusBadge = styled('span')(({ status }) => ({
  padding: '4px 8px',
  borderRadius: '999px',
  fontSize: ajustarTamanhoFonteEscola('0.75rem'),
  fontWeight: 500,
  backgroundColor: 
    status === 'aprovado' ? "var(--sear-sucesso-fundo, #e2f4ed)" :
    status === 'correcao' ? "var(--sear-erro-fundo, #ffeded)" :
    "var(--sear-aviso-fundo, #fff3da)",
  color: 
    status === 'aprovado' ? "var(--sear-sucesso-texto, #128465)" :
    status === 'correcao' ? "var(--sear-erro-texto, #c34949)" :
    "var(--sear-aviso-texto, #9c6a0d)",
  transition: 'all 0.3s ease'
}));

const DocumentStatus = ({ aprovacao, alteracao_ativa }) => {
  let label = 'Em análise';
  let status = 'analise';

  if (aprovacao === true && alteracao_ativa === false) {
    label = 'Documento aprovado';
    status = 'aprovado';
  } else if (aprovacao === false && alteracao_ativa === true) {
    label = 'Correção solicitada';
    status = 'correcao';
  } else if (aprovacao === false && alteracao_ativa === false) {
    label = 'Em análise';
    status = 'analise';
  }

  return <StatusBadge status={status}>{label}</StatusBadge>;
};

export default DocumentStatus;
